import React, {useState} from "react";

import './PostponeNotificationModal.scss'
import {ADD, useToastContext} from "../../Toast";
import {useRecoilState, useRecoilValue} from "recoil";
import {postponeAlarmModalOpenState, selectedAlarmState} from "../../../state/alerts_table";
import {grpcAlarmServiceSelector} from "../../../state/grpc";
import {Modal, Select, SelectItem} from "@carbon/react";
import dayjs from "dayjs";
import PropTypes from "prop-types";

const PostponeNotificationModal = (props) => {
  const { toastDispatch } = useToastContext();
  const selectedAlarm = useRecoilValue(selectedAlarmState)
  const [postponeAlarmOpen, setPostponeAlarmOpen]  = useRecoilState(postponeAlarmModalOpenState)
  const alarmsService = useRecoilValue(grpcAlarmServiceSelector)
  const [scheduleDelay, setScheduleDelay] = useState(300)

  return (
    <Modal
      open={postponeAlarmOpen}
      modalHeading="Ritarda le notifiche per questo allarme"
      modalLabel="Dati allarme"
      primaryButtonText="Salva"
      secondaryButtonText="Annulla"
      onRequestSubmit={() => {
        let notifySchedule = dayjs(selectedAlarm.notifySchedule, 'DD/MM/YYYY HH:mm')
        notifySchedule = notifySchedule.add(scheduleDelay, "seconds")
        const req = new proto.api.UpdateAlarmRequest()
        let alarm = new proto.api.Alarm()
        alarm.setId(selectedAlarm.id)
        alarm.setNotifySchedule(notifySchedule.format("DD/MM/YYYY HH:mm:ss"))
        req.setAlarm(alarm)
        alarmsService.updateAlarm(req, null, (err, resp) => {
          if (err != null) {
            console.error(err)
            toastDispatch({
              type: ADD,
              payload: {
                title: "Operazione fallita",
                content: "Impossibile posporre la notifica. Riprova più tardi",
                kind: "error",
                caption: err.message
              }
            })
          } else {
            toastDispatch({
              type: ADD,
              payload: {
                title: "Operazione avvenuta con successo",
                content: "Notifica allarme rimandata",
                kind: "success"
              }
            })
            props.onAlarmPostponed()
          }
        })
      }}
      onRequestClose={() => {
        setPostponeAlarmOpen(false)
      }}>
      <p style={{marginBottom: 'rem'}}>
        Questa interfaccia ti consente di posporre le notifiche per l'allarme selezionato. Hai la possibilità
        di scegliere di quanto ritardare l'invio delle notifiche tra le opzioni disponibili nel menù a tendina
        presente nel contenuto di questa modale.
        Ti ricordiamo che una volta applicata la configurazione, l'ordine con cui l'allarme viene visualizzato nella
        tabella degli allarmi attivi potrebbe subire variazioni.
        Infatti, la tabella degli allarmi attivi è ordinata anche sulla base di questo dato.
      </p>
      <br/>
      <p>
        Prossima notifica dell'allarme prevista il: {selectedAlarm.notifySchedule}
      </p>
      <br/>
      <Select
        id="alarm-schedule"
        labelText="Opzioni di ritardo"
        data-modal-primary-focus
        style={{marginBottom: 'rem'}}
        value={scheduleDelay}
        onChange={ev => {
          setScheduleDelay(ev.target.value)
        }}>
        <SelectItem text="5 minuti" value="300" />
        <SelectItem text="15 minuti" value="900" />
        <SelectItem text="30 minuti" value="1800" />
        <SelectItem text="1 ora" value="3600" />
        <SelectItem text="2 ore" value="7200" />
        <SelectItem text="4 ore" value="14400" />
      </Select>
    </Modal>
  );
}

PostponeNotificationModal.propTypes = {
  onAlarmPostponed: PropTypes.func.isRequired,
}

export default PostponeNotificationModal